import React from "react";
import BounceLoader from "react-spinners/BounceLoader";

export default function Loader({ withMargins, style, size }) {
  return (
    <div className={`loader ${withMargins ? "margins" : ""}`} style={withMargins ? {} : style || {}}>
      <BounceLoader sizeUnit={"px"} size={size || 30} color="#3ca9a6" loading={true} />
    </div>
  );
}
